import { useThemeStore } from "@/betby/store/themeStore";

export function useThemeViewModel() {
  const theme = useThemeStore((state) => state.theme);

  return {
    theme,
  };
}
